module.exports = __webpack_public_path__ + "img/gc4.1084115e.png";